
  import { ProcessStatus } from '@/entities/settings'
  import { Component } from 'vue-property-decorator'
  import Cell from './cell'

@Component
  export default class EmployeeStatusCell extends Cell {
    get status (): ProcessStatus {
      const { item } = this

      if (!item) return

      return item.status
    }
  }
